import Vue from "vue";
import App from "./App";
import router from "./router";
import VueI18n from "vue-i18n";
// import "./assets/main.css";
import YDUI from "vue-ydui"; /* 相當於import YDUI from 'vue-ydui/ydui.rem.js' */
import "vue-ydui/dist/ydui.px.css";

import "swiper/dist/css/swiper.min.css";

import { Popover } from "element-ui";

import rem from "./config/rem";

//三種語言包
import LangZhCHS from "../static/lang/zhCHS";
import LangZhCHT from "../static/lang/zhCHT";

Vue.use(YDUI);
Vue.use(VueI18n);
Vue.use(Popover);
Vue.config.productionTip = false;

const i18n = new VueI18n({
  locale: sessionStorage.getItem("lang-key") || "zhCHT",
  messages: {
    zhCHS: LangZhCHS,
    zhCHT: LangZhCHT
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  i18n,
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js